/* eslint-disable react-refresh/only-export-components */
import React from 'react';

import { ToastContainer, toast } from 'react-toastify';
import './Toast.scss';
import 'react-toastify/dist/ReactToastify.css';

import { reloadApp } from '@utils/reloadApp';
import {
  CloseIcon,
  ErrorIcon,
  ReloadIcon,
  SuccessIcon,
  WarningIcon,
} from '@assets/icons';
import { RawButton } from '@shared/RawButton';

export const showErrorApiToast = (text: string) => {
  toast.error(
    <div
      style={{
        gap: '8px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <span>{text}</span>

      <div
        style={{
          width: '24px',
          height: '24px',
          margin: '-3px 4px -3px 0',
        }}
      >
        <RawButton onClick={reloadApp}>
          <ReloadIcon />
        </RawButton>
      </div>
    </div>,
    {
      icon: <ErrorIcon />,
      closeButton: (
        <div style={{ width: '24px', height: '24px', margin: '-3px 0' }}>
          <CloseIcon />
        </div>
      ),
    },
  );
};

export const showSuccessToast = (text: string, colorText?: string) => {
  toast.success(
    <div>
      <span style={{ color: '#39C074' }}>{colorText}</span> {text}
    </div>,
    { icon: <SuccessIcon /> },
  );
};

export const showErrorToast = (text: string) => {
  toast.error(text, { icon: <ErrorIcon /> });
};

export const showErrorSmartToast = (text: string, isSystem: boolean) => {
  if (isSystem) showErrorApiToast(text);
  else showErrorToast(text);
};

export const showWarningToast = (text: string) => {
  toast.warning(text, { icon: <WarningIcon /> });
};

export const Toast: React.FC = () => {
  return (
    <ToastContainer
      closeOnClick
      pauseOnHover
      pauseOnFocusLoss
      autoClose={5000}
      closeButton={false}
      position="top-center"
      hideProgressBar={false}
      toastStyle={{ backgroundColor: '#113D30' }}
    />
  );
};
